import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.83 7.7H8.16v2.76H12c-.19.94-.71 1.67-1.46 2.14-.64.41-1.46.63-2.37.63-1.88 0-3.46-1.21-4.01-2.9v-.01A3.85 3.85 0 0 1 3.94 9c0-.46.08-.91.21-1.33a4.21 4.21 0 0 1 4.01-2.9c1.01 0 1.92.36 2.63.94l2.08-2.08c-1.27-1.1-2.89-1.79-4.71-1.79-2.83 0-5.25 1.62-6.42 3.98-.46.97-.73 2.04-.73 3.18 0 1.14.26 2.21.73 3.17a7.13 7.13 0 0 0 6.42 3.98c1.74 0 3.41-.62 4.66-1.78 1.31-1.22 2.17-3.04 2.17-5.37 0-.42-.07-.88-.16-1.3z"
    }, null, -1)
  ])))
}
export default { render };